import baseMixin from '~/mixins/base'

export default {
    mixins: [baseMixin],

    data() {
        return {
            defaultInputConfig: {
                horizontal: {
                    label: 'col-sm-2',
                    input: 'col-sm-10'
                },
                size: 'sm',
                class: "font-weight-bold"
            },
            defaultSelectConfig: {
                horizontal: {
                    label: 'col-sm-2',
                    input: 'col-sm-10'
                },
                size: 'sm',
                class: "font-weight-bold"
            },

            messages: {
                create: {
                    header: "¡_save!",
                    body: "saved_successfully",
                    color: 'success',
                },
                update: {
                    header: "¡_update!",
                    body: "changes_have_been_saved_successfully",
                    color: 'success',
                },
                delete: {
                    header: "¡_delete!",
                    body: "successfully_removed",
                    color: 'success',
                },
                error: {
                    header: '¡_error!',
                    body: "there_was_a_problem",
                    color: 'danger'
                }
            }
        }


    },



    computed: {

    },
    methods: {
        /**
         * 
         * @param {*} fieldName field name to validate.
         * @description Check if a field defined in the vue validates option is valid.
         * **Important.-  This funcion work together with module vuelidate.
         */
        checkIfFormValid({ formName, fieldName }) {
            const field = this.$v.forms[formName][fieldName];
            if (!field.$dirty) {
                return null
            }
            return !(field.$invalid || field.$model === '')
        },

        checkIfFormTableFieldValid({ tableName, index, fieldName }) {
            let field = this.$v.tables[tableName].items.$each[index][fieldName];
            if (!field.$dirty) {
                return null
            }
            return !(field.$invalid || field.$model === '')
        },

        async loadForm({ formName, data }) {
            let form = this.forms[formName];
            if (!form) {
                throw new Error();
            }
            for (const key in form) {
                if (Object.hasOwnProperty.call(form, key) && Object.hasOwnProperty.call(data, key)) {
                    form[key] = data[key];
                }
            }

            this.forms = {
                ...this.forms,
                [formName]: form
            }
        },

        async formParseData({ data }) {
            return data;
        },

        async updateForm({ formName, url, method = 'GET', adapterData, fetch }) {
            let data = await this.fetcher({
                url,
                method,
                ...fetch
            });

            let matchResponse = this.forms[formName]._matchResponse;

            if (matchResponse) {
                data = data[matchResponse];
            }

            if (adapterData && typeof adapterData === 'function') {
                data = await adapterData(data);
            }

            data = await this.formParseData({
                data
            });
            await this.loadForm({
                formName,
                data
            });
        },

        isInvalidForm(formName) {
            let valForm = this.getValidateForm(formName);
            if (!valForm) return false;
            valForm.$touch();
            return valForm.$invalid;
        },

        getForm(formName) {
            return this.forms[formName] || this.form;
        },

        getValidateForm(formName) {
            return this.$v.forms[formName] || this.$v.form;
        },

        async submitForm(e, formName) {
            e.preventDefault();
            console.warn('submitForm not implemented');
            return null;
        },

        executeSubmitForm(formName) {
            this.$refs[formName].requestSubmit();
        },

        /**
         * 
         * @param {*} formData 
         * @returns object with the form data without fields starts with _
         */

        cleanFormData(formData) {
            for (const key in formData) {
                if (Object.hasOwnProperty.call(formData, key)) {
                    // delete field if key start by _
                    if (key[0] == "_") {
                        delete formData[key];
                    }
                }
            }

            return formData;
        },

        /** 
         * @description Set all fields in the form to null
         */
        resetForm(formName) {
            let form = this.getForm(formName);
            for (const key in form) {
                if (Object.hasOwnProperty.call(form, key)) {
                    form[key] = null;
                }
            }
            return form;
        },

        resetForms() {
            let forms = this.forms;
            for (const key in forms) {
                if (Object.hasOwnProperty.call(forms, key)) {
                    this.resetForm(key)
                }
            }
        },


        /**
         * @description Hace la peticion al servidor para enviar los datos del formulario y muestra los mensajes dependiendo de la respuesta del servidor
         * @param {*} param0 
         * @returns 
         */

        async sendForm({ formName, url, method = 'POST', customMessage, normalize = false, adapterData, fetch }) {
            let vForm = this.getForm(formName);
            let form = { ...vForm };
            try {

                vForm._loading = true;

                if (this.isInvalidForm(formName)) {
                    throw new Error("invalid_data");
                };
                form = this.cleanFormData(form);

                if (adapterData && typeof adapterData === 'function') {
                    form = await adapterData(form);
                }
                if (normalize) {
                    form = this.normalizeObject(form, true);
                }

                let data = await this.fetcher({
                    data: form,
                    url,
                    method,
                    ...fetch
                });

                if (customMessage) {
                    this.$store.dispatch('toast/addFixedToasts', {
                        ...customMessage
                    });
                } else if (method == 'PUT') {
                    this.$store.dispatch('toast/addFixedToasts', {
                        ...this.messages.update
                    });
                } else {
                    this.$store.dispatch('toast/addFixedToasts', {
                        ...this.messages.create
                    });
                }

                vForm._loading = false;

                return {
                    status: true,
                    data
                }

            } catch (error) {
                this.showMessageError(error);
                vForm._loading = false;
                throw error;
            }


        },


    },
    async mounted() {
    },
}